  document.addEventListener('DOMContentLoaded', function () {
    const popup = document.getElementById('genericSignupPopup');
    if (!popup) return;

    // Show popup after 3 seconds
    setTimeout(() => {
      popup.classList.add('active');
    }, 3000);

    popup.querySelector('.GenericPopup__close').onclick = () => {
      popup.classList.remove('active');
    };

    popup.querySelector('.GenericPopup__overlay').onclick = () => {
      popup.classList.remove('active');
    };
  });